import {Box} from 'src/design/atoms/Box';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormSubformV2Props {
  field: IFormFieldV2;
}

export const FormSubformV2 = React.memo<FormSubformV2Props>(
  ({field}: FormSubformV2Props) => {
    if (!field.subFormOptions?.showPreviewComponent) {
      return null;
    }

    return (
      <Box data-testid={`form-field-${field.name}`} mb="md">
        <Box
          style={{
            height: '20rem',
            width: '100%',
            background:
              'repeating-linear-gradient(45deg, #f3efef, #f3efef 10px,#f5f7ff 10px, #f5f7ff 20px)',
          }}>
          <Text p="lg" c="dimmed" size="md">
            Subform Placeholder for '{field.label}'
          </Text>
        </Box>
      </Box>
    );
  }
);
